import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { OperatorGroupPermission } from '@/schema'

export default function useHasPermission(permission: OperatorGroupPermission) {
	const { data: user } = useQueryProfile()
	const hasWritePermission =
		user?.userGroup.writePermission.includes(permission)

	return hasWritePermission
}
